import dayjs from 'dayjs';

const MONTHS = ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'];

/**
 * Previsão do mês atual tirada do gráfico do período: realizados até agora
 * mais o que ainda está marcado até o fim do mês. Só aparece quando o período
 * cobre o mês inteiro (senão o "por vir" ficaria cortado) e o agrupamento
 * permite separar o mês: por mês, por dia ou, por semana, só se o período é
 * exatamente o mês. Devolve { month, done, upcoming, expected } ou null.
 */
export function currentMonthForecast(timeline, granularity, period) {
  if (!timeline || !period) return null;
  const today = dayjs();
  const monthStart = today.startOf('month').format('YYYY-MM-DD');
  const monthEnd = today.endOf('month').format('YYYY-MM-DD');
  if (period.start > monthStart || period.end < monthEnd) return null;

  const monthKey = today.format('YYYY-MM');
  const exactMonth = period.start === monthStart && period.end === monthEnd;
  const inMonth = (point) => {
    if (granularity === 'month') return point.bucket === monthKey;
    if (granularity === 'day') return String(point.bucket).startsWith(monthKey);
    return exactMonth;
  };

  const points = timeline.filter(inMonth);
  if (points.length === 0) return null;
  const done = points.reduce((sum, point) => sum + (Number(point.done) || 0), 0);
  const upcoming = points.reduce((sum, point) => sum + (Number(point.upcoming) || 0), 0);
  if (done + upcoming === 0) return null;
  return { month: MONTHS[today.month()], done, upcoming, expected: done + upcoming };
}
